export const imagesArt = {
  picasso: require("./picasso-art.webp"),
  gogh: require("./van-gogh-art.webp"),
  rembrandt: require("./rembrandt-art.webp"),
  edvard: require("./munch-art.webp"),
  klimt: require("./klimt-art.webp"),
  cezanne: require("./cezanne-art.webp"),
  fridakahlo: require("./kahlo-art.webp"),
};
